import { SectionErrorBoundary } from './shared'

import type { ReactNode } from 'react'

/**
 * Fixed section spacing and background per slot kind.
 * Colors defined in tailwind.config.js.
 */
const SECTION_CLASS = {
  category: 'py-12 md:py-20 bg-section-cream',
  promo: 'py-12 md:py-20 bg-section-gray',
  slider: 'py-3 md:py-6 bg-white',
}

/** Content container: max-width + centered + mobile padding. Sections keep full-width bg. */
const CONTENT = 'max-w-homepage mx-auto px-4 md:px-0'

interface HomepageSlotProps {
  /** Section name for error logging */
  name: string
  errorMessage: string
  /** 'banner' is full-bleed: no background, no content container */
  kind: 'banner' | keyof typeof SECTION_CLASS
  children: ReactNode
}

/** One homepage slot: a section that fails alone, with its own message, background and content width. */
export function HomepageSlot({ name, errorMessage, kind, children }: HomepageSlotProps) {
  return (
    <SectionErrorBoundary sectionName={name} errorMessage={errorMessage}>
      {kind === 'banner' ? (
        <section>{children}</section>
      ) : (
        <section className={SECTION_CLASS[kind]}>
          <div className={CONTENT}>{children}</div>
        </section>
      )}
    </SectionErrorBoundary>
  )
}
